import { dispatchCustomEvent } from "@/helpers/triggerAnalyticsEvent";
import XButton from "@/icons/x-button.svg?react";
import { useState } from "react";

function  setURLParams(input: string) {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set("expanded",input);
  history.pushState(
    null,
    "",
    `${window.location.pathname}?${urlParams.toString()}`
  );
}

function scrollToOffset(element, offset=0) {
  const rect = element.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  window.scrollTo({
    top: rect.top + scrollTop - offset,
    behavior: "smooth",
  });
}
const BetaBanner = ({ showBeta }: { showBeta: boolean }) => {
  const [open, setOpen] = useState(true);
  const setExpandedParams = () => {
    setURLParams("true#examples");
    const ele = document.getElementById("examples");
    scrollToOffset(ele,180);
    
  };

  const handleClick = () => {
    dispatchCustomEvent({
      dataObject: "body-betaToolTip",
      dataType: "link",
      dataReason: "joyhunt_see_examples",
    });
    setExpandedParams();
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (!open) {
    return;
  }

  return (
    <div className="peer-focus-within:hidden relative bottom-2 sm:left-12 w-fit max-w-[548px] z-50">
      <div className="triangle" />
      <div className="bg-charcoal xs:h-[60px] sm:h-[50px] max-w-[548px] smallish:h-[47px] flex items-center rounded-[2px] relative text-white">
        <span className="ml-[20px] text-[16px] mt-3 mb-2 xs:my-0 mr-6">
          Type a sentence describing your shopping inspiration.{" "}
          {showBeta ? (
            <button
              onClick={handleClick}
              className="syfclickevent inline-block"
              id="see-examples"
              data-object="body-betaToolTip"
              data-type="button"
              data-reason="joyhunt_see_examples"
              tabIndex={0}
            >
              <span className="uppercase text-syfYellow font-bold mx-[14px] sm:mx-0 text-[16px] ">
                See Examples
              </span>
            </button>
          ) : null}
          <button
            className="absolute right-1 top-1 p-1"
            onClick={handleClose}
            aria-label="Close"
          >
            <XButton />
          </button>
        </span>
      </div>
    </div>
  );
};

export default BetaBanner;
